module.exports = __webpack_public_path__ + "img/t6.41601f63.png";